import { IAppState } from '../../redux';

export const selectIsRecommendedPackagesAvailable = (state: IAppState): boolean => {
  return state.recommendedPackages.packages.length > 0;
};
